module.exports = __webpack_public_path__ + "static/media/export.ec4468d5.jpg";